<template>
   <v-row class="d-flex justify-center" no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8" class="">
            <v-row class="pt-4 px-5 justify-center">
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" class="d-flex justify-center">
                     <!-- class="d-flex justify-center" style="border-top-radius: 100px !important;"-->
                     <div style="width: 300px !important; border: 0px solid black;">
                         <v-img contain :src="require('@/assets/tfw_logo_light.png')" />
                    </div>
                </v-col>
            </v-row>

            <v-row class="pt-4 px-5 justify-center">
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <strong class=" font-weight-bold text-h5 primary--text">Welcome to SWAPP<br /><span class="text-h5 font-weight-thin black--text">the Safe Workplace App</span></strong> <br /><br />At Transport For Wales, the wellbeing of our staff, contractors and the general public remains our top priority. If you require access to a TfW RL Maintenance Depot, you will need to logon to SWAPP.
                </v-col>            
            </v-row>
            <v-row class="px-5 justify-center">
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5"> 
                    <p class="mt-3 mb-0 text-left text-body-2 font-weight-bold">Please enter your email address and password below to login.</p>
                    <v-divider></v-divider>
                </v-col> 
            </v-row>
   
            <v-row class="d-flex justify-center mt-1">
                <v-col cols="11" xs="11" sm="5" class="pa-3">
                    <firebase-auth-login />
                </v-col>
            </v-row>

            <v-row class="d-flex justify-center text-center mt-1">
                <v-col cols="10" xs="10" sm="6">
                    <router-link :to="{ path: 'reset-password' }" replace class="btn btn-link black--text" >Forgot Password</router-link>       
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'Login',
}
</script>